import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { type ApolloResult } from "../../shared/models";
import { type SpectaclesTagsQuery, getSpectaclesTags } from "../api/queries";

type UseSpectaclesTagsReturn = ApolloResult<{
    spectaclesTags: Set<string>;
}>;

export const useSpectaclesTags = (): UseSpectaclesTagsReturn => {
    const { data, loading, error } = useQuery<SpectaclesTagsQuery>(getSpectaclesTags);

    return useMemo(() => {
        return {
            loading,
            error,
            spectaclesTags: new Set(data?.spectaclesTags ?? []),
        };
    }, [data?.spectaclesTags, error, loading]);
};
